import React from 'react';
import images from '../../constants/images';

import './ContactBtn.scss' 

const ContactBtn = () => {
  return (
    <a href="#footer">
      <img
          id='contactBtn'
          src={images.contactBtn}
          alt='contact-button'
      />
    </a>
  )
}

export default ContactBtn